import AsyncCreatableReactSelect from 'react-select/async-creatable';
import createSelect from './createSelect';
var AsyncCreatableSelect = createSelect(AsyncCreatableReactSelect);
export default AsyncCreatableSelect;